// extracted by mini-css-extract-plugin
export default {"skeleton-tabs":"QCHXR","skeleton-tabs_size_m":"utPda","skeleton-tabs_size_s":"FMVHw"};